import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deletePublicVideo } from "../api";

/** Deletes one of the user's own clips and refreshes the feed on success. */
export function useDeletePublicVideo() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deletePublicVideo,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["public-videos"] });
    },
  });
}
